import { giphyDarkGrey } from '@giphy/js-brand'
import styled from 'styled-components'
import { getCssBackgroundFromColorString } from '../../../../utils/color-utils'
import { StickerBlock } from '../../../blocks'
import ColorPicker from '../../../color-picker'
import DropdownComponent from '../../../dropdown'
import { Subtitle } from '../../../typography'
import { SourceEditorCaptionStyle } from '../../types'

const Dropdown = styled(DropdownComponent)`
    flex-shrink: 0;
`

const StrokeColor = styled(StickerBlock)`
    border-radius: inherit;
    box-sizing: border-box;
    padding: 5px;
`

const StrokeCutout = styled.div`
    background: ${giphyDarkGrey};
    border-radius: inherit;
    height: 100%;
    width: 100%;
`

const ColorOptions = styled.div`
    width: 280px;
`

type Props = {
    captionStyle: SourceEditorCaptionStyle
    setCaptionStyle: (style: SourceEditorCaptionStyle) => void
}

const CreationSourceEditorCaptionStrokeDropdown = ({ captionStyle, setCaptionStyle }: Props) => {
    const { strokeColor } = captionStyle

    const onColorChange = (strokeColor: string) => {
        setCaptionStyle({
            ...captionStyle,
            strokeColor,
        })
    }

    return (
        <Dropdown
            {...{
                preview: (
                    <StrokeColor style={{ background: getCssBackgroundFromColorString(strokeColor) }}>
                        {!!strokeColor && <StrokeCutout />}
                    </StrokeColor>
                ),
            }}
        >
            <ColorOptions>
                <Subtitle>Outline Options</Subtitle>
                <ColorPicker
                    {...{
                        allowEmpty: true,
                        columns: 7,
                        defaultColor: strokeColor,
                        showInput: true,
                        onColorChange,
                    }}
                />
            </ColorOptions>
        </Dropdown>
    )
}

export default CreationSourceEditorCaptionStrokeDropdown
